import React from 'react';
import { SessionBackgroundData } from '../pages/Session';

type BackgroundProps = {
  background: SessionBackgroundData | null;
};

const Background: React.FC<BackgroundProps> = ({ background }) => {
  if (!background) {
    return null;
  }
  if (background.isVideo) {
    return (
      <video className="background" autoPlay loop muted playsInline>
        <source src={background.url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  }
  return <img className="background" src={background.url} />;
};

export default Background;
